import React, { useEffect, useRef } from 'react';

const ramp = (t) => {
  const s = [[2, 6, 23], [8, 80, 140], [34, 211, 238], [251, 146, 60], [255, 255, 255]];
  const x = Math.max(0, Math.min(0.999, t)) * (s.length - 1), i = Math.floor(x), f = x - i;
  return s[i].map((c, k) => Math.round(c + (s[i + 1][k] - c) * f));
};

export const SpectroPanel = ({ clip, response, frac, onSeek }) => {
  const ref = useRef(null);
  const an = clip?.analysis;
  useEffect(() => {
    const cv = ref.current; if (!cv || !an) return;
    const n = an.cols.length, B = an.cols[0]?.length || 96;
    cv.width = n; cv.height = B;
    const g = cv.getContext('2d'), img = g.createImageData(n, B);
    an.cols.forEach((col, x) => col.forEach((v, b) => {
      const [r, gg, bb] = ramp((v - an.lo) / (an.hi - an.lo)), o = ((B - 1 - b) * n + x) * 4;
      img.data[o] = r; img.data[o + 1] = gg; img.data[o + 2] = bb; img.data[o + 3] = 255;
    }));
    g.putImageData(img, 0, 0);
    an.formants.forEach((f, x) => {
      if (!f) return;
      [[f.f1, '#f472b6'], [f.f2, '#a3e635']].forEach(([hz, c]) => { g.fillStyle = c; g.fillRect(x, B - 1 - (hz / an.maxHz) * B, 1.2, 1.2); });
    });
  }, [an]);
  const labels = response?.labels || clip?.aligned || [];
  const dur = response?.duration_s || 1;
  const cur = labels.find((l) => frac * dur >= l.t0 && frac * dur < l.t1);
  return (
    <div className="space-y-2" data-testid="spectro-panel">
      {an ? (
        <div className="relative cursor-crosshair" onClick={(e) => { const r = e.currentTarget.getBoundingClientRect(); onSeek((e.clientX - r.left) / r.width); }}>
          <canvas ref={ref} className="w-full h-40 rounded-xl" style={{ imageRendering: 'pixelated' }} data-testid="spectrogram-canvas" />
          <div className="absolute top-0 bottom-0 w-0.5 bg-amber-400" style={{ left: `${frac * 100}%` }} />
          <span className="absolute top-1 left-2 text-[10px] text-white/70">0–4 kHz · <span className="text-pink-400">F1</span> · <span className="text-lime-400">F2</span></span>
        </div>
      ) : <p className="text-xs text-slate-500">Lo spettrogramma appare quando la bocca imita un audio (microfono, clip o testo).</p>}
      <div className="relative h-9 rounded-lg bg-slate-950 border border-slate-800 overflow-hidden" data-testid="ipa-timeline">
        {labels.map((l, i) => (
          <span key={i} className={`absolute top-1 bottom-1 flex items-center justify-center rounded font-mono text-sm transition-colors ${cur === l ? 'bg-amber-400 text-slate-950' : 'bg-cyan-500/15 text-cyan-100'}`}
            style={{ left: `${(l.t0 / dur) * 100}%`, width: `calc(${((l.t1 - l.t0) / dur) * 100}% - 2px)` }} title={l.word || ''}>{l.sym}</span>
        ))}
        {!labels.length && <span className="absolute inset-0 flex items-center justify-center text-[11px] text-slate-500">{clip && clip.aligned === undefined && clip.wav ? 'Trascrizione IPA in corso…' : 'Trascrizione IPA allineata'}</span>}
      </div>
      {cur && <p className="text-xs text-amber-300" data-testid="ipa-current">Ora: /{cur.sym}/ {cur.word ? `in “${cur.word.trim()}”` : ''}</p>}
    </div>
  );
};
